// extracted by mini-css-extract-plugin
export default {"container":"zo-z","bubbleNav":"Ao-z","graphic":"Bo-z","contact":"Co-z"};